var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 9.99967C1.66797 6.85698 1.66797 5.28563 2.64428 4.30932C3.62059 3.33301 5.19194 3.33301 8.33464 3.33301H11.668C14.8107 3.33301 16.382 3.33301 17.3583 4.30932C18.3346 5.28563 18.3346 6.85698 18.3346 9.99967V11.6663C18.3346 14.809 18.3346 16.3804 17.3583 17.3567C16.382 18.333 14.8107 18.333 11.668 18.333H8.33463C5.19194 18.333 3.62059 18.333 2.64428 17.3567C1.66797 16.3804 1.66797 14.809 1.66797 11.6663V9.99967Z",
    stroke: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 3.33301V2.08301",
    stroke: "#424242",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 3.33301V2.08301",
    stroke: "#424242",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.75,
    cy: 13.75,
    r: 1.25,
    stroke: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 7.5H17.9154",
    stroke: "#424242",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender3);
export default __webpack_public_path__ + "static/media/calender3.38a4e7938b1843ce8a189941a84ff8d9.svg";
export { ForwardRef as ReactComponent };